var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowInLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "16px",
    viewBox: "0 0 23 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Arrow_2094738") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone-Booth-Availability",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RoomLanding_PhoneBoothSensors_D",
    transform: "translate(-1379.000000, -107.000000)",
    fill: "#ffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Arrow_2094738",
    transform: "translate(1390.500000, 35.000000) rotate(-360.000000) translate(-1390.500000, -35.000000) translate(1379.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4819152,0.289808319 C15.2834084,0.0552996517 14.9674267,-0.0485538662 14.6657625,0.0215638211 C14.3640983,0.0916815083 14.1285595,0.323728315 14.0573867,0.620920304 C13.9862139,0.918112293 14.0916302,1.2294094 14.3296678,1.42497334 L20.2084339,7.22339624 L0.776934277,7.22339624 C0.341343142,7.24616425 0,7.60076161 0,8.03049857 C0,8.46023552 0.341343142,8.81483288 0.776934277,8.83760089 L20.2084339,8.83760089 L14.3204499,14.6292128 C14.0125973,14.9468276 14.0125973,15.446763 14.3204499,15.7643778 C14.4730809,15.9152187 14.6803812,16 14.8965735,16 C15.1127659,16 15.3200662,15.9152187 15.4726972,15.7643778 L22.7549006,8.59013492 C22.9115086,8.44162333 23,8.23670177 23,8.02255241 C23,7.80840305 22.9115086,7.60348149 22.7549006,7.4549699 L15.4819152,0.289808319 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowInLink);
export default __webpack_public_path__ + "static/media/RightArrowInLink.3fb084076ec10366d30503c914a16b58.svg";
export { ForwardRef as ReactComponent };